import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'
export default {
  name: 'naturaCreationSubido',
  mixins: [mixx],
  data() {
    return {
      loading: false,
  
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/natura/reporte/creation/subido?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  
} 



// WEBPACK FOOTER //
// ./src/components/reportes/naturaCreationSubido/index.js